import api from '../../../services/api';
import buildQuery from 'odata-query'

export const TRAINING_URL = '/traininguser'

/**
 * Retorna a justificativa
 * @param {int} id 
 * @returns {Array}
 */
export function fetchTrainingUsers(standardId) {

    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(standardId)
        },
        select: ['*'],
        expand: {
            user: {
                select: ['id', 'name', 'sap'],
                expand: [
                    'companyRole',
                    'deparment'
                ]
            }
        }      
    }))
}

/**
 * Retorna a justificativa
 * @param {int} id 
 * @returns {Array}
 */
export function fetchTrainingOneUser(standardId, userId) {

    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(standardId),
            userId: parseInt(userId)
        },
        count: true,
        select: ['*'],
    }))
}